import Stack from 'components/Stack';
import styled from 'styled-components';

const Card = styled.div`
    box-shadow: 0px 2px 3px rgba(0, 0, 0, 0.07);
    background-color: ${({ theme }) => theme.gray_7};
    border-radius: ${({ theme }) => theme.borderRadius_lg};
    padding: ${({ theme }) => theme.space_9}px;
    padding-top: ${({ theme }) => theme.space_7}px;
    font-family: ${({ theme }) => theme.style_primary};
    font-size: ${({ theme }) => theme.fontSize_base};
    line-height: ${({ theme }) => theme.space_10}px;
    color: ${({ theme }) => theme.gray_1};
`;

export const SectionCardHeading = styled.div`
    display: flex;
    flex-wrap: wrap;

    & > * {
        margin: 0px;
        display: inline;
        font-size: inherit;
        font-family: inherit;
        line-height: inherit;
    }
`;

export const SectionCardH1 = styled.h1`
    font-weight: ${({ theme }) => theme.fontExtrabold};
    text-transform: capitalize;
    margin-right: 0.5ch;
`;

export const SectionCardSubH1 = styled.h2`
    font-weight: normal;
    color: ${({ theme }) => theme.gray_4};
`;

const IconWrapper = styled.span`
    margin-right: ${({ theme }) => theme.space_4}px;
    color: ${({ theme }) => theme.gray_4};
`;

export function SectionCardIcon({ Icon, ...props }) {
    return (
        <IconWrapper {...props}>
            <Icon style={{ minWidth: '1.25em', height: '1.25em' }} />
        </IconWrapper>
    );
}

const headingSpace = (theme) => `${theme.space_6}px`;

export function SectionCard({ space = headingSpace, children, ...props }) {
    return (
        <Card {...props}>
            <Stack $space={space}>{children}</Stack>
        </Card>
    );
}
